import "flowbite-react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";

import { i18n } from "./modules/i18n";
import "./utils/pdfWorker"; // Initialize PDF.js worker early

import "./index.css";
// to use Cypress.env in e2e environment
declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    Cypress?: { env: (key: string) => string };
  }
}

async function setupApp() {
  await i18n.configure();
}

const root = createRoot(document.getElementById("root")!);

setupApp()
  .then(() => {
    root.render(<App />);
  })
  .catch((error) => {
    console.error("Something went wrong in setting up app", error);
  });
